var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-list"},[_c('article-list',{attrs:{"title":_vm.$ebsn.meta(_vm.config, 'categoryblocktype_ArticleList.TITLE'),"article-list":_vm.articleList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }